import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-super-savings',
  templateUrl: './super-savings.component.html',
  styleUrls: ['./super-savings.component.scss']
})
export class SuperSavingsComponent {}
